// services/api.js
const API_BASE_URL = 'https://app.prabhatmemorialhospital.com/api';

export const blogAPI = {
  // Get paginated blog list
getBlogs: async (page = 1, perPage = 6) => {
    try {
      console.log(`Fetching blogs from: ${API_BASE_URL}/blogs?page=${page}&per_page=${perPage}`);
      
      const response = await fetch(`${API_BASE_URL}/blogs?page=${page}&per_page=${perPage}`);
      
      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('API Response data:', data);
      return data;
      
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error;
    }
  },

  // Get individual blog by slug
getBlogBySlug: async (slug) => {
  try {
    console.log(`Fetching blog by slug: ${slug}`);
    const response = await fetch(`${API_BASE_URL}/blogs/${slug}`);
    console.log('Blog Response status:', response.status);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Blog API response data:', data);
    return data;
    
  } catch (error) {
    console.error('Error fetching blog:', error);
    throw error;
  }
},
  // Get related blogs (you might need to adjust this based on your API)
getRelatedBlogs: async (currentSlug, department = '') => {
  try {
    console.log(`Fetching related blogs for: ${currentSlug}, department: ${department}`);
    
    // Try different API endpoints based on what's available
    let url = `${API_BASE_URL}/blogs?exclude=${currentSlug}&limit=3`;
    if (department) {
      url += `&department=${encodeURIComponent(department)}`;
    }
    
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    console.log('Related blogs response:', data);
    
    // Handle different response structures
    return data.data || data.blogs || data || [];
    
  } catch (error) {
    console.error('Error fetching related blogs:', error);
    return [];
  }
}
};

// Utility functions
export const utils = {
  // Generate excerpt from HTML content
  generateExcerpt: (htmlContent, length = 150) => {
    if (!htmlContent) return 'No content available';
    
    // Remove HTML tags and get plain text
    const plainText = htmlContent.replace(/<[^>]*>/g, '');
    
    // Truncate to specified length
    return plainText.length > length 
      ? plainText.substring(0, length) + '...' 
      : plainText;
  },

  // Calculate read time from HTML content
  calculateReadTime: (htmlContent) => {
    if (!htmlContent) return '2-5 min';
    
    const plainText = htmlContent.replace(/<[^>]*>/g, '');
    const wordCount = plainText.split(/\s+/).length;
    const readTimeMinutes = Math.ceil(wordCount / 150); // 200 words per minute
    
    return `${readTimeMinutes} min`;
  },

  // Format date
  formatDate: (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }
};